import { render, staticRenderFns } from "./tenant-edit.vue?vue&type=template&id=2a31375e&"
import script from "./tenant-edit.vue?vue&type=script&lang=js&"
export * from "./tenant-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports